import React from "react";
import "./privacy.css";

export default function PrivacyFmcAurora() {
  return (
    <div className="overview1-container">
      <h2>개인정보처리방침 (FMC Aurora)</h2>

      <div className="overview1-row">
        <div className="overview1-title">문서 개요</div>
        <div className="overview1-value">
          본 개인정보처리방침은 “FMC Aurora” 앱(이하 “앱”)의 개인정보 처리 기준을 안내합니다.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">수집하는 개인정보</div>
        <div className="overview1-value">
          앱은 개인정보를 수집, 저장, 또는 제3자와 공유하지 않습니다.
          (이름, 이메일, 전화번호, 정밀 위치정보 등)
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">권한 사용</div>
        <div className="overview1-value">
          앱은 호환 장치와 연결 및 제어를 위해 Bluetooth 기능을 사용합니다.
          Android 버전에 따라 Bluetooth / Nearby Devices 권한이 필요할 수 있으며,
          해당 권한은 장치 연결 목적에 한해 사용됩니다.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">데이터 저장</div>
        <div className="overview1-value">
          앱 설정(예: 선택한 장치, 제어 설정값 등)은 사용자 기기 내에 로컬로 저장될 수 있습니다.
          외부 서버로 전송되지 않습니다.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">제3자 제공</div>
        <div className="overview1-value">
          앱은 개인정보를 제3자에게 제공하거나 공유하지 않습니다.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">문의</div>
        <div className="overview1-value">
          이메일: <a href="mailto:tama@ta-ma.net">tama@ta-ma.net</a>
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">시행일</div>
        <div className="overview1-value">2026-02-15</div>
      </div>

      <hr style={{ margin: "28px 0" }} />

      <h2>Privacy Policy (FMC Aurora)</h2>

      <div className="overview1-row">
        <div className="overview1-title">Overview</div>
        <div className="overview1-value">
          This Privacy Policy explains how the FMC Aurora app (“App”) handles information.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">Personal Data</div>
        <div className="overview1-value">
          The App does not collect, store, or share personal information (e.g., name, email, phone, precise location).
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">Permissions</div>
        <div className="overview1-value">
          The App uses Bluetooth to connect to and control compatible devices. Depending on Android version,
          Bluetooth / Nearby Devices permissions may be required solely for device connectivity.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">Local Storage</div>
        <div className="overview1-value">
          Configuration values may be stored locally on the user’s device. No data is transmitted to external servers.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">Contact</div>
        <div className="overview1-value">tama@ta-ma.net</div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">Effective Date</div>
        <div className="overview1-value">2026-02-15</div>
      </div>
    </div>
  );
}
